import { optionTitle_pbpSharingOptions } from './SharePbpOption.locstring.json';
import { optionTitle_pbp } from './strings.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
import getPublishedStatus from 'owa-pbp-option-publishing-settings/lib/selectors/getPublishedStatus';
import getShownView from 'owa-pbp-option/lib/selectors/getShownView';
import PersonalBookingPageShownView from './data/store/schema/PersonalBookingPageShownView';
import getAnonymousSharingStatus from 'owa-pbp-option-publishing-settings/lib/selectors/getAnonymousSharingStatus';

var lazyFullModule = new LazyModule(() => import('./lazyFullSharePbpOption'));
let SharePbpOption: LazyOption = createLazyOption(
    {
        key: 'sharePbpOption',
        titleStringKey: optionTitle_pbpSharingOptions,
        searchTermsStringKey: optionTitle_pbp,
        isHidden: () => {
            return (
                !isFeatureEnabled('cal-personalbookingpage') ||
                getShownView() != PersonalBookingPageShownView.Main ||
                !getPublishedStatus() ||
                !getAnonymousSharingStatus()
            );
        },
    },
    lazyFullModule,
    m => m.default
);

export default SharePbpOption;
